import { LinkedinLogo, FacebookLogo, InstagramLogo, TiktokLogo } from "@phosphor-icons/react";
import { api } from "../../lib/api";

export const NETWORKS = {
  linkedin: { label: "LinkedIn", icon: LinkedinLogo, color: "#0A66C2", provider: "linkedin", limit: 3000 },
  facebook: { label: "Facebook", icon: FacebookLogo, color: "#1877F2", provider: "meta", limit: 63206 },
  instagram: { label: "Instagram", icon: InstagramLogo, color: "#D62976", provider: "meta", limit: 2200 },
  tiktok: { label: "TikTok", icon: TiktokLogo, color: "#111111", provider: "tiktok", limit: 2200 },
};
export const NETWORK_IDS = Object.keys(NETWORKS);

export const STATUS = {
  draft: { label: "Brouillon", cls: "bg-zinc-100 text-zinc-700 border-zinc-200" },
  pending_approval: { label: "À valider", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  rejected: { label: "Refusé", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  scheduled: { label: "Programmé", cls: "bg-sky-50 text-sky-800 border-sky-200" },
  publishing: { label: "Publication…", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  published: { label: "Publié", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  partial: { label: "Publié en partie", cls: "bg-orange-50 text-orange-800 border-orange-200" },
  failed: { label: "Échec", cls: "bg-red-50 text-red-700 border-red-200" },
};

export const TIKTOK_PRIVACY = [
  { id: "PUBLIC_TO_EVERYONE", label: "Public" },
  { id: "MUTUAL_FOLLOW_FRIENDS", label: "Amis" },
  { id: "FOLLOWER_OF_CREATOR", label: "Abonnés" },
  { id: "SELF_ONLY", label: "Moi uniquement" },
];

export function StatusBadge({ status }) {
  const s = STATUS[status] || STATUS.draft;
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium ${s.cls}`}
      data-testid={`social-status-${status}`}>{s.label}</span>
  );
}

export function NetworkDot({ id, size = 14, muted = false }) {
  const n = NETWORKS[id];
  if (!n) return null;
  const Icon = n.icon;
  return <Icon size={size} weight="fill" style={{ color: muted ? "#a1a1aa" : n.color }} aria-label={n.label} />;
}

export const errMsg = (e) => e?.response?.data?.detail || e?.message || "Erreur";

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("fr-FR", {
  day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
}) : "—");

const CHUNK = 5 * 1024 * 1024;

export async function uploadMedia(file, onProgress) {
  const init = await api.post("/social/media/init", {
    filename: file.name, content_type: file.type || "application/octet-stream", size: file.size,
  });
  const id = init.data.upload_id;
  for (let off = 0; off < file.size; off += CHUNK) {
    await api.put(`/social/media/${id}/chunk`, file.slice(off, off + CHUNK), {
      headers: { "Content-Type": "application/octet-stream" },
    });
    onProgress?.(Math.min(100, Math.round(((off + CHUNK) / file.size) * 100)));
  }
  return (await api.post(`/social/media/${id}/complete`)).data;
}
